export default __webpack_public_path__ + "static/media/floaters-mid@3x.8bb726e3.jpg";